import { render } from "./Labels.vue?vue&type=template&id=db6a1cc6&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"

import "./Labels.vue?vue&type=style&index=0&id=db6a1cc6&lang=scss&scoped=true"
import "./Labels.vue?vue&type=style&index=1&id=db6a1cc6&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6a1cc6"]])

export default __exports__